import { Control, useWatch } from 'react-hook-form';

import { Focused } from 'react-credit-cards-2';
import CardCredit from '~/components/CardCredit';

function CardComponent({ control, focused }: { control: Control<any>; focused: Focused }) {
  const number = useWatch({
    control,
    name: 'number',
    defaultValue: ''
  });
  const cvv = useWatch({
    control,
    name: 'cvv',
    defaultValue: ''
  });
  const expiry = useWatch({
    control,
    name: 'expiry',
    defaultValue: ''
  });
  const name = useWatch({
    control,
    name: 'name',
    defaultValue: ''
  });

  return (
    <>
      <CardCredit number={number} cvc={cvv} expiry={expiry} focused={focused} name={name} />
    </>
  );
}

export default CardComponent;
